import { render, staticRenderFns } from "./electricityPayment.vue?vue&type=template&id=3835fe02&scoped=true"
import script from "./electricityPayment.vue?vue&type=script&lang=js"
export * from "./electricityPayment.vue?vue&type=script&lang=js"
import style0 from "./electricityPayment.vue?vue&type=style&index=0&id=3835fe02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835fe02",
  null
  
)

export default component.exports